/*************************************************/
/* 3rd Party                                     */
/*************************************************/
window.$ = window.jQuery = require("jquery");
require("jquery-match-height");
import { mmenu } from "./partials/mmenu.js";
import { inview } from "./partials/inview.js";


/*************************************************/
/* Vue                                           */
/*************************************************/
import Vue from "vue";
import VueRouter from "vue-router";
import GlobalContact from "./vue/globalcontact.vue";

const appGlobalContact = "#app-globalcontact";

if (document.querySelectorAll(appGlobalContact).length) {

    const router = new VueRouter({
        mode: "history"
    });
    Vue.use(VueRouter);

    if (document.querySelectorAll(appGlobalContact).length) {
        var globalContact = new Vue({
            el: appGlobalContact,
            render: h => h(GlobalContact),
            router
        });
    }
}

/*************************************************/
/* Partials                                      */
/*************************************************/
import { news } from "./partials/news.js";
import { video } from "./partials/video.js";
import { language } from "./partials/language.js";
import { slider } from "./partials/slider.js";
import { header } from "./partials/header.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { cards } from "./partials/cards.js";
import { accordion } from "./partials/accordion.js";
import { linkAccordion } from "./partials/linkSliderAccordion.js";


/*************************************************/
/* Global variables                              */
/*************************************************/
const $body = $("body"),
    bodyLoadingClass = "is-loading",
    currentCulture = $("html").attr("lang");

/*************************************************/
/* Init                                          */
/*************************************************/
$(document).ready(function () {

      //Handle scroll to submitted form element
      const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
      if (formSubmittedElement) {
          window.scrollTo(0, formSubmittedElement.closest('.form-item').offsetTop);
      }

    mmenu();
    inview();
    news($body, bodyLoadingClass, currentCulture);
    header($body);
    language();
    slider();
    video();
    cookies();
    cards();
    accordion();
    linkAccordion();
    modal($body, bodyLoadingClass);
});



// WEBPACK FOOTER //
// ./src/scripts/main.js